import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { getOrderResourceType } from '../../../_utils/get-resource-type.js';
import { ICONS } from '@app/styles';
export class Renderer_GroupOrder extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state.order = nextProps.order;
        state.resourceType = getOrderResourceType(state.order);
        return state;
    }
    //######################### Render #########################
    render() {
        return _jsxs(Button, { variant: 'group-order', onClick: e => this.props.onClick(this.state.order), children: [this.render_Icon(), _jsx("div", { className: 'order-name', children: this.state.order.name })] });
    }
    render_Icon = () => {
        switch (this.state.resourceType) {
            case 'consult':
                return _jsx(ICONS.advisor_avn_consultation.component, {});
            case 'ekg':
                return _jsx(ICONS.advisor_avn_ekg.component, {});
            case 'imaging':
                return _jsx(ICONS.advisor_avn_imaging.component, {});
            case 'treatment':
                return _jsx(ICONS.advisor_avn_medication.component, {});
            default:
                return _jsx(ICONS.advisor_avn_labs.component, {});
        }
    };
}
//# sourceMappingURL=Renderer_GroupOrder.js.map